<template>
  <div
    v-touch="{
      left : () => swipe('left'),
      right: () => swipe('right'),
    }"
  >
    <!-- Dialogs, Alerts, Snackbars -->
    <v-snackbar
      v-model="swipedDate"
      :multi-line="true"
      :timeout="2000"
    >
      <p style="align-content: center">
        {{ humanReadableDate }}
      </p>

      <v-btn
        flat
        @click="swipedDate = false"
      >
        Close
      </v-btn>
    </v-snackbar>

    <!-- Weather refresh success/error status -->
    <v-snackbar
      v-model="weatherSnackbar.show"
      :timeout="weatherSnackbar.timeout"
      :color="weatherSnackbar.color"
      :multi-line="true"
    >
      {{ weatherSnackbar.text }}
    </v-snackbar>

    <h1>{{ project.name }}</h1>

    <v-tabs
      color="primary"
      :value="1"
    >
      <v-tab @click="goTo('/projects/' + $route.params.projectId)">
        <span class="white--text">
          Uvodni list
        </span>
      </v-tab>
      <v-tab @click="goTo('/projects/' + $route.params.projectId+ '/journals')">
        <span class="white--text">
          Dnevni listi
        </span>
      </v-tab>
      <v-tab @click="goTo('/projects/' + $route.params.projectId+ '/pictures')">
        <span class="white--text">
          Slike
        </span>
      </v-tab>
    </v-tabs>

    <v-form>
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Dnevni list na {{ humanReadableDate }}</v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            @click="exportAsPdf"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <div>
            <v-switch
              v-model="printWithImages"
              hide-details
              label="Natisni s slikami"
            />
          </div>
        </v-toolbar>

        <v-card-text>
          <v-text-field
            :value="osnovniPodatki.izvajalec"
            label="Izvajalec"
            disabled
          />
          <v-text-field
            :value="osnovniPodatki.objekt"
            label="Objekt"
            disabled
          />
          <v-text-field
            :value="osnovniPodatki.investitor"
            label="Naročnik"
            disabled
          />
          <v-text-field
            :value="sequence"
            label="Dnevno poročilo številka"
            disabled
          />
          <v-text-field
            slot="activator"
            :value="humanReadableDate"
            label="za dan"
            disabled
          />

          <v-text-field
            :value="dnevniList.delovni_cas.od"
            :disabled="!canEditProject"
            label="Delovni čas od"
            @change="updateSiteLogField($event, 'delovni_cas.od')"
          />
          <v-text-field
            :value="dnevniList.delovni_cas.do"
            :disabled="!canEditProject"
            label="Delovni čas do"
            @change="updateSiteLogField($event, 'delovni_cas.do')"
          />
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Vremenske razmere
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <table class="v-datatable v-table theme--light">
            <thead>
              <tr>
                <th>
                  Vremenske razmere ob uri
                  <v-tooltip bottom>
                    <v-icon
                      slot="activator"
                    >
                      info
                    </v-icon>
                    <span>Vpiši vsaj za jutranji, dopoldanski in popoldanski čas</span>
                  </v-tooltip>
                </th>

                <th
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.merjeno_ob"
                    :disabled="!canEditProject"
                    label="Ura"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.merjeno_ob')"
                    @focus="$event.target.select()"
                  />

                  <v-btn
                    icon
                    :disabled="!canEditProject"
                    @click="populateWeather(index, vremenskeRazmere.merjeno_ob, true)"
                  >
                    <v-icon>refresh</v-icon>
                  </v-btn>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>vreme</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.vreme"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.vreme')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>temperatura zraka °C</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.temperatura"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.temperatura')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>višina padavin (sneg, dež)</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.padavine_mm"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.padavine_mm')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>vodostaj</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.vodostaj_cm"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.vodostaj_cm')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>hitrost vetra (m/s) in smer</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.hitrost_vetra_ms"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.hitrost_vetra_ms')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>drugi pogoji</td>
                <td
                  v-for="(vremenskeRazmere, index) in dnevniList.vremenske_razmere"
                  :key="vremenskeRazmere.merjeno_ob"
                >
                  <v-text-field
                    :value="vremenskeRazmere.drugi_pogoji"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'vremenske_razmere.' + index + '.drugi_pogoji')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Delavci na gradbišču
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <table class="v-datatable v-table theme--light">
            <thead>
              <tr>
                <th />
                <th>delovna sila izvajalca</th>
                <th>najeta dolovna sila</th>
                <th>podizvajalci, kooperanti</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>vodstvo</td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.vodstvo.izvajalci"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.vodstvo.izvajalci')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.vodstvo.najeti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.vodstvo.najeti')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.vodstvo.kooperanti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.vodstvo.kooperanti')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>delavci za gradbena dela</td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.gradbena_dela.izvajalci"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.gradbena_dela.izvajalci')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.gradbena_dela.najeti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.gradbena_dela.najeti')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.gradbena_dela.kooperanti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.gradbena_dela.kooperanti')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>delavci za obrtna dela</td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.obrtniki.izvajalci"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.obrtniki.izvajalci')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.obrtniki.najeti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.obrtniki.najeti')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.obrtniki.kooperanti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.obrtniki.kooperanti')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>delavci za inštalacijska dela</td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.instalaterji.izvajalci"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.instalaterji.izvajalci')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.instalaterji.najeti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.instalaterji.najeti')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.instalaterji.kooperanti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.instalaterji.kooperanti')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td>delavci za druga dela</td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.drugi.izvajalci"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.drugi.izvajalci')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.drugi.najeti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.drugi.najeti')"
                    @focus="$event.target.select()"
                  />
                </td>
                <td>
                  <v-text-field
                    placeholder="0"
                    :value="dnevniList.delavci.drugi.kooperanti"
                    :disabled="!canEditProject"
                    @change="updateSiteLogField($event, 'delavci.drugi.kooperanti')"
                    @focus="$event.target.select()"
                  />
                </td>
              </tr>
              <tr>
                <td><b>skupaj</b></td>
                <td>
                  <v-text-field
                    :value="delavciIzvajalciSkupaj"
                    disabled
                  />
                </td>
                <td>
                  <v-text-field
                    :value="delavciNajetiSkupaj"
                    disabled
                  />
                </td>
                <td>
                  <v-text-field
                    :value="delavciDrugiSkupaj"
                    disabled
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Stroji
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <h3>Izvajalčevi</h3>

          <v-container
            v-for="stroj in dnevniList.stroji.izvajalec"
            :key="stroj.id"
            grid-list-md
            text-xs-center
          >
            <v-layout>
              <v-flex
                xs8
              >
                <v-text-field
                  :value="stroj.description"
                  label="Opis stroja"
                  @change="updateMachineDescription($event, stroj.id, 'izvajalec')"
                />
              </v-flex>

              <v-flex
                xs3
              >
                <v-text-field
                  :value="stroj.count"
                  label="Število strojev"
                  @change="updateMachineCount($event, stroj.id, 'izvajalec')"
                  @focus="$event.target.select()"
                />
              </v-flex>

              <v-flex
                xs1
              >
                <v-btn
                  icon
                  @click="odstraniStroj('izvajalec', stroj.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>

          <v-btn
            :disabled="!canEditProject"
            @click="dodajStroj('izvajalec')"
          >
            Dodaj stroj
          </v-btn>

          <h3>Drugi</h3>

          <v-container
            v-for="stroj in dnevniList.stroji.drugi"
            :key="stroj.id"
            grid-list-md
            text-xs-center
          >
            <v-layout>
              <v-flex
                xs8
              >
                <v-text-field
                  :value="stroj.description"
                  :disabled="!canEditProject"
                  label="Opis stroja"
                  @change="updateMachineDescription($event, stroj.id, 'drugi')"
                />
              </v-flex>

              <v-flex
                xs3
              >
                <v-text-field
                  :value="stroj.count"
                  :disabled="!canEditProject"
                  label="Število strojev"
                  @change="updateMachineCount($event, stroj.id, 'drugi')"
                  @focus="$event.target.select()"
                />
              </v-flex>

              <v-flex
                xs1
              >
                <v-btn
                  icon
                  :disabled="!canEditProject"
                  @click="odstraniStroj('drugi', stroj.id)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>

          <v-btn
            :disabled="!canEditProject"
            @click="dodajStroj('drugi')"
          >
            Dodaj stroj
          </v-btn>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Sporočila naročniku
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-textarea
            :value="dnevniList.sporocila_narocniku"
            :disabled="!canEditProject"
            label="kratek tehnični opis del, ki se na objektu dnevno izvajajo, podatki o nepredvidenih in interventnih delih"
            auto-grow
            @change="updateSiteLogField($event, 'sporocila_narocniku')"
          />
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Sestavil
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            :value="dnevniList.sestavil"
            :disabled="!canEditProject"
            label="ime in priimek, podpis"
            @change="updateSiteLogField($event, 'sestavil')"
          />

          <div v-show="dnevniList.signature_sestavil">
            <img
              id="signature-sestavil-signed"
              style="width: 50%; height: 50%;"
              :src="dnevniList.signature_sestavil"
            >
          </div>

          <v-dialog
            v-model="dialog_signature_sestavil"
            persistent
            fullscreen
            hide-overlay
          >
            <v-btn
              slot="activator"
              color="primary"
              :disabled="!canEditProject"
              @click.stop="dialog_signature_sestavil = true"
            >
              Podpiši
            </v-btn>

            <v-card>
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialog_signature_sestavil = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Prostor za lastoročni podpis</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    dark
                    flat
                    color="error"
                    @click="clearSignature('signature-sestavil')"
                  >
                    Počisti
                  </v-btn>
                  <v-btn
                    dark
                    flat
                    @click="sign('signature-sestavil'); dialog_signature_sestavil = false;"
                  >
                    Podpiši
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <canvas
                id="signature-sestavil"
                width="400"
                height="200"
              />
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Odgovorni nadzornik oz. odgovorni nadzornih posameznih del
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            :value="dnevniList.odgovorni"
            :disabled="!canEditProject"
            label="ime in priimek, podpis"
            @change="updateSiteLogField($event, 'odgovorni')"
          />

          <div v-show="dnevniList.signature_odgovorni">
            <img
              id="signature-odgovorni-signed"
              style="width: 50%; height: 50%;"
              :src="dnevniList.signature_odgovorni"
            >
          </div>

          <v-dialog
            v-model="dialog_signature_odgovorni"
            persistent
            fullscreen
            hide-overlay
          >
            <v-btn
              slot="activator"
              color="primary"
              :disabled="!canEditProject"
              @click.stop="dialog_signature_odgovorni = true"
            >
              Podpiši
            </v-btn>

            <v-card>
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialog_signature_odgovorni = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Prostor za lastoročni podpis</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    dark
                    flat
                    color="error"
                    @click="clearSignature('signature-odgovorni')"
                  >
                    Počisti
                  </v-btn>
                  <v-btn
                    dark
                    flat
                    @click="sign('signature-odgovorni'); dialog_signature_odgovorni = false;"
                  >
                    Podpiši
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <canvas
                id="signature-odgovorni"
                width="400"
                height="200"
              />
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Odgovorni vodja del oz odgovorni vodja posameznih del
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            :value="dnevniList.nadzorni"
            label="ime in priimek, podpis"
            :disabled="!canEditProject"
            @change="updateSiteLogField($event, 'nadzorni')"
          />

          <div v-show="dnevniList.signature_nadzorni">
            <img
              id="signature-nadzorni-signed"
              style="width: 50%; height: 50%;"
              :src="dnevniList.signature_nadzorni"
            >
          </div>

          <v-dialog
            v-model="dialog_signature_nadzorni"
            persistent
            fullscreen
            hide-overlay
          >
            <v-btn
              slot="activator"
              color="primary"
              :disabled="!canEditProject"
              @click.stop="dialog_signature_nadzorni = true"
            >
              Podpiši
            </v-btn>

            <v-card>
              <v-toolbar
                dark
                color="primary"
              >
                <v-btn
                  icon
                  dark
                  @click="dialog_signature_nadzorni = false"
                >
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Prostor za lastoročni podpis</v-toolbar-title>
                <v-spacer />
                <v-toolbar-items>
                  <v-btn
                    dark
                    flat
                    color="error"
                    @click="clearSignature('signature-nadzorni')"
                  >
                    Počisti
                  </v-btn>
                  <v-btn
                    dark
                    flat
                    @click="sign('signature-nadzorni'); dialog_signature_nadzorni= false;"
                  >
                    Podpiši
                  </v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <canvas
                id="signature-nadzorni"
                width="400"
                height="200"
              />
            </v-card>
          </v-dialog>
        </v-card-text>
      </v-card>

      <div
        class="secondary"
        style="height: 3px;"
      />

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Dopolnilni del
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-textarea
            :value="dnevniList.dopolnilni_del"
            :disabled="!canEditProject"
            label="Dodatne ugotovitve, navodila, sporočila in pripombe ter vpisi in vrisi (sporočila izvajalcu)"
            auto-grow
            @change="updateSiteLogField($event, 'dopolnilni_del')"
          />
        </v-card-text>

        <v-card-text>
          <v-textarea
            :value="dnevniList.opombe_in_zahteve_odgovornega_vodje"
            :disabled="!canEditProject"
            label="Opombe in zahteve odgovornega vodje projekta za pridobitev gradbenega dovoljenja"
            auto-grow
            @change="updateSiteLogField($event, 'opombe_in_zahteve_odgovornega_vodje')"
          />
        </v-card-text>

        <v-card-text>
          <v-textarea
            :value="dnevniList.opombe_in_zahteve_inspekcijskih_sluzb"
            :disabled="!canEditProject"
            label="Opombe in zahteve inšpekcijskih služb"
            auto-grow
            @change="updateSiteLogField($event, 'opombe_in_zahteve_inspekcijskih_sluzb')"
          />
        </v-card-text>

        <v-card-text>
          <v-textarea
            :value="dnevniList.opombe_in_zahteve_projektantov"
            :disabled="!canEditProject"
            label="Opombe in zahteve odgovornih projektantov ter strokovnjakov z drugih področij"
            auto-grow
            @change="updateSiteLogField($event, 'opombe_in_zahteve_projektantov')"
          />
        </v-card-text>

        <v-card-text>
          <v-textarea
            :value="dnevniList.opombe_in_zahteve_soglasodajalcev"
            :disabled="!canEditProject"
            label="Opombe in zahteve soglasodajalcev"
            auto-grow
            @change="updateSiteLogField($event, 'opombe_in_zahteve_soglasodajalcev')"
          />
        </v-card-text>

        <v-card-text>
          <v-textarea
            :value="dnevniList.opombe_ali_odgovori_izvajalca_del"
            :disabled="!canEditProject"
            label="Opombe ali odgovori izvajalca del"
            auto-grow
            @change="updateSiteLogField($event, 'opombe_ali_odgovori_izvajalca_del')"
          />
        </v-card-text>
      </v-card>

      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>
            Priponke
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-text-field
            v-if="canEditProject"
            ref="attachment"
            v-model="attachment"
            type="file"
            prepend-icon="file"
            label="Priponka"
            :rules="attachmentRules"
            required
          />

          <v-btn
            v-if="canEditProject"
            color="info"
            :loading="uploadInProgress"
            @click="uploadAttachment"
          >
            Pripni
          </v-btn>

          <ul v-if="attachments">
            <li
              v-for="attachment in attachments"
              :key="attachment.attachment_id"
            >
              <a :href="attachment.download_url">
                {{ attachment.original_name }}
              </a>
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
  import SignaturePad from 'signature_pad';
  import crypto from 'crypto';
  import firebase from 'firebase';
  import router from '../router';
  import moment from 'moment';
  import can_write_project from '../model/user/permissions/can_write_project';

  export default {
    data: () => ({
      // Print options
      printWithImages: true,

      // Attachment
      uploadInProgress: false,
      attachment: null,
      attachmentRules: [
        v => !!v || 'Priponka je obvezna',
      ],

      // Dialogs
      dialog_signature_sestavil: false,
      dialog_signature_odgovorni: false,
      dialog_signature_nadzorni: false,

      // Signature pads
      signaturePads: {
        'signature-sestavil': null,
        'signature-odgovorni': null,
        'signature-nadzorni': null,
      },

      // Snackbars
      swipedDate: false,
      weatherSnackbar: {
        show: false,
        color: 'success',
        timeout: 2000,
        text: ''
      }
    }),
    computed: {
      canEditProject() {
        const currentUser = this.$store.state.currentUser;

        return can_write_project(currentUser, this.project);
      },
      sequence() {
        return this.$route.params.sequence || 1;
      },
      humanReadableDate() {
        return moment(this.$route.params.journalDate).format('dddd, DD.MM.YYYY');
      },
      project() {
        return this.$store.state.listOfProjects.find(p => p.project_id === this.$route.params.projectId);
      },
      osnovniPodatki() {

        const objekt     = this.$store.getters.uvodniListSection(this.$route.params.projectId, 1);
        const investitor = this.$store.getters.uvodniListSection(this.$route.params.projectId, 2);
        const izvajalec  = this.$store.getters.uvodniListSection(this.$route.params.projectId, 3);

        return {
          izvajalec: izvajalec.naziv,
          objekt: objekt.vrsta_objekta,
          investitor: investitor. naziv
        };
      },
      dnevniList() {
        return this.$store.getters.dnevniList(this.$route.params.projectId, this.$route.params.journalDate);
      },
      delavciIzvajalciSkupaj() {
        return (
          (parseInt(this.dnevniList.delavci.vodstvo['izvajalci']) || 0) +
          (parseInt(this.dnevniList.delavci.gradbena_dela['izvajalci']) || 0) +
          (parseInt(this.dnevniList.delavci.obrtniki['izvajalci']) || 0) +
          (parseInt(this.dnevniList.delavci.instalaterji['izvajalci']) || 0) +
          (parseInt(this.dnevniList.delavci.drugi['izvajalci']) || 0)
        );
      },
      delavciNajetiSkupaj() {
        return (
          (parseInt(this.dnevniList.delavci.vodstvo['najeti']) || 0) +
          (parseInt(this.dnevniList.delavci.gradbena_dela['najeti']) || 0) +
          (parseInt(this.dnevniList.delavci.obrtniki['najeti']) || 0) +
          (parseInt(this.dnevniList.delavci.instalaterji['najeti']) || 0) +
          (parseInt(this.dnevniList.delavci.drugi['najeti']) || 0)
        );
      },
      delavciDrugiSkupaj() {
        return (
          (parseInt(this.dnevniList.delavci.vodstvo['kooperanti']) || 0) +
          (parseInt(this.dnevniList.delavci.gradbena_dela['kooperanti']) || 0) +
          (parseInt(this.dnevniList.delavci.obrtniki['kooperanti']) || 0) +
          (parseInt(this.dnevniList.delavci.instalaterji['kooperanti']) || 0) +
          (parseInt(this.dnevniList.delavci.drugi['kooperanti']) || 0)
        );
      },
      attachments() {
        return this.dnevniList.attachments || [];
      },
    },
    async created() {
      await this.$store.dispatch('fetchSiteLog', {
        projectId: this.$route.params.projectId,
        date     : this.$route.params.journalDate
      })

      this.drawSignatures();
    },
    methods: {
      drawSignatures() {
        const sestavilCanvas = document.getElementById('signature-sestavil');
        this.signaturePads['signature-sestavil'] = new SignaturePad(sestavilCanvas, {
          backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });

        sestavilCanvas.width = window.innerWidth;
        sestavilCanvas.height = window.innerHeight - 64;

        const odgovorniCanvas = document.getElementById('signature-odgovorni');
        this.signaturePads['signature-odgovorni'] = new SignaturePad(odgovorniCanvas, {
          backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });

        odgovorniCanvas.width = window.innerWidth;
        odgovorniCanvas.height = window.innerHeight - 64;

        const nadzorniCanvas = document.getElementById('signature-nadzorni');
        this.signaturePads['signature-nadzorni'] = new SignaturePad(nadzorniCanvas, {
          backgroundColor: 'rgb(255, 255, 255)' // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });

        nadzorniCanvas.width = window.innerWidth;
        nadzorniCanvas.height = window.innerHeight - 64;

        if (this.$route.query.swipe) {
          this.swipedDate = true;
        }
      },
      swipe(direction) {
        let goToDate     = null;
        let goToSequence = null;

        if ('right' === direction) {
          // Previous sitelog
          goToDate     = this.$store.getters.previousSiteLogDate(this.$route.params.projectId, this.$route.params.journalDate);
          goToSequence = _.padStart(parseInt(this.sequence) - 1, 3, '0');
        } else if ('left' === direction) {
          // Next sitelog
          goToDate     = this.$store.getters.nextSiteLogDate(this.$route.params.projectId, this.$route.params.journalDate);
          goToSequence = _.padStart(parseInt(this.sequence) + 1, 3, '0');
        }

        if (null !== goToDate && null !== goToSequence) {
          this.goTo(`/projects/${this.$route.params.projectId}/journals/${goToDate}/${goToSequence}?swipe=true`);
          this.swipedDate = true;
        }
      },
      goTo(href) {
        router.push(href);
      },
      dodajStroj(tipStroja) {
        this.$store.dispatch('addMachineToSiteLog', {
          projectId: this.$route.params.projectId,
          date: this.$route.params.journalDate,
          type: tipStroja,
          description: '',
          count: 1
        });
      },
      odstraniStroj(tipStroja, strojId) {
        this.$store.dispatch('removeMachineFromSiteLog', {
          projectId: this.$route.params.projectId,
          date: this.$route.params.journalDate,
          id: strojId,
          type: tipStroja
        });
      },
      updateMachineDescription(description, id, type) {
        this.$store.dispatch('updateMachineOnSiteLog', {
          projectId: this.$route.params.projectId,
          date: this.$route.params.journalDate,
          id: id,
          type: type,
          description: description
        });
      },
      updateMachineCount(count, id, type) {
        this.$store.dispatch('updateMachineOnSiteLog', {
          projectId: this.$route.params.projectId,
          date: this.$route.params.journalDate,
          id: id,
          type: type,
          count: count
        });
      },
      updateSiteLogField(value, fieldPath) {
        const projectId = this.$route.params.projectId;
        const date      = this.$route.params.journalDate;

        this.$store.dispatch('updateSiteLogField', { projectId, date, fieldPath, value });
      },
      async uploadAttachment() {
        if (this.$refs.attachment.validate()) {
          this.uploadInProgress = true;

          const projectId  = this.$route.params.projectId;
          const date       = this.$route.params.journalDate;
          const attachment = this.$refs.attachment.$refs.input.files[0];

          await this.$store.dispatch('uploadSiteLogAttachment', { projectId, date, attachment });

          this.uploadInProgress = false;
          this.$refs.attachment.reset();
        }
      },
      async populateWeather(index, time) {
        const db = firebase.firestore();

        const krajZaVreme   =
          (this.$store.getters.uvodniListSection(this.$route.params.projectId, 1).kraj_za_vreme) ||
          (this.$store.getters.uvodniListSection(this.$route.params.projectId, 1).kraj_gradnje)
        ;
        const observationAt = `${this.$route.params.journalDate} ${time}`;

        const locationId = crypto
          .createHash('md5')
          .update(krajZaVreme.trim().toLowerCase())
          .digest('hex')
        ;

        const result = await db
          .collection('weather_observations')
          .where('location_id', '==', locationId)
          .where('observed_at', '==', observationAt)
          .limit(1)
          .get()
        ;

        if (1 === result.size) {
          const observation = result.docs[0].data().observations;

          this.updateSiteLogField(observation.clouds, 'vremenske_razmere.' + index + '.vreme');
          this.updateSiteLogField(observation.temperature, 'vremenske_razmere.' + index + '.temperatura');
          this.updateSiteLogField(observation.precipitation, 'vremenske_razmere.' + index + '.padavine_mm');
          this.updateSiteLogField(observation.wind_and_direction, 'vremenske_razmere.' + index + '.hitrost_vetra_ms');

          this.weatherSnackbar.text    = `Vreme za lokacijo "${krajZaVreme}" ob ${moment(observationAt).format('H:mm')} je osveženo`;
          this.weatherSnackbar.color   = 'success';
          this.weatherSnackbar.timeout = 2000;
          this.weatherSnackbar.show    = true;
        } else {
          const requestedLocation = (
            await db
              .collection('weather_locations')
              .doc(locationId)
              .get())
            .data()
          ;

          let text = `Vreme za kraj "${krajZaVreme}" ob ${moment(observationAt).format('H:mm')} ni na voljo.`;

          if (krajZaVreme.length < 1) {
            text = `Prosimo izpolnite "Kraj gradnje" na uvodne listu! Kraj gradnje potrebujemo za pridobitev vremena.`;
          } else if (moment(observationAt) > moment()) {
            text = `
              Aplikacija omogoča samodjeno izpoljevanje preteklega vremena.
              Vremenskih napovedi ne pridobivamo. Prosimo poskusite ponovno po ${moment(observationAt).format('DD.MM.YYYY H:mm')}.
            `;
          } else if (requestedLocation && requestedLocation.ok === true) {
            text = `
              Vreme za kraj "${krajZaVreme}" sicer spremljamo, vendar žal za čas ob ${moment(observationAt).format('H:mm')} ni na voljo.
              Če se napaka pogosto pojavlja nas prosimo obvesite na support@sitelog.si.
            `;
          } else if (requestedLocation && requestedLocation.ok === false) {
            text = `
              Vremena za kraj "${krajZaVreme}" ne moremo pridobiti. Poskusite lahko z alternativno lokacijo za vreme, ki jo lahko spremenite na uvodnem listu. Potem poskusite ponovno.
              Če težave ne morete odpravite, nam pišite na support@sitelog.si.
            `;
          }

          this.weatherSnackbar.text    = text;
          this.weatherSnackbar.color   = 'error';
          this.weatherSnackbar.timeout = 6000;
          this.weatherSnackbar.show    = true;
        }
      },

      /**
       * Signature methods
       */
      clearSignature(signatureId) {
        const signaturePad = this.signaturePads[signatureId];

        signaturePad.clear();
      },

      async sign(signatureId) {
        const signaturePad       = this.signaturePads[signatureId];
        const base64PngSignature = signaturePad.toDataURL('image/png');
        document.getElementById(`${signatureId}-signed`).src = base64PngSignature;

        await this.updateSiteLogField(base64PngSignature, signatureId.replace('-', '_'));
      },

      /**
       * Export
       */
      async exportAsPdf() {


        const url = `${this.$config.API_PDF_EXPORT_BASE}/dnevni-list/${this.$route.params.projectId}/${this.$route.params.journalDate},${this.sequence}?withPhotos=${this.printWithImages}`;

        window.open(url, '_blank');
      }
    }
  }
</script>
